<template>
  <v-container fluid class="d-flex align-center justify-center" style="min-height: 90vh;">
    <v-row justify="center">
      <v-col cols="12" sm="8" md="4" lg="4">
        <v-card class="pa-6 rounded-xl elevation-10">
          <v-card-text>
            <div class="text-center mb-6">
              <v-img
                src="@/assets/images/Blu.png"
                alt="Blú Capital"
                width="150"
                contain
                class="mx-auto"
              />
            </div>

            <v-form ref="form" v-model="isValid" lazy-validation>
              <v-text-field
                v-model="username"
                label="Correo Electrónico"
                name="username"
                prepend-inner-icon="mdi-email"
                placeholder="Ingresa tu correo electrónico"
                :rules="emailRules"
                outlined
                dense
                color="primary"
                required
                autocomplete="username"
              />
              <v-text-field
                v-model="password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                :type="showPassword ? 'text' : 'password'"
                label="Contraseña"
                name="password"
                prepend-inner-icon="mdi-lock"
                :rules="passwordRules"
                outlined
                dense
                color="primary"
                required
                autocomplete="current-password"
              />

              <v-btn
                block
                rounded
                color="primary"
                dark
                class="font-weight-bold mt-4 py-3"
                @click="login"
              >
                Iniciar sesión
              </v-btn>

              <div class="text-center mt-3 caption grey--text text--darken-1">
                Al iniciar sesión aceptas nuestro
                <a
                  href="https://blucapital.mx/aviso_de_privacidad.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="privacy-link"
                >
                  Aviso de Privacidad
                </a>
              </div>


              <div class="text-center mt-3">
                <v-btn
                  text
                  color="primary"
                  @click="recoverPass"
                >
                  ¿Olvidaste tu contraseña?
                </v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      isValid: true,
      username: '',
      password: '',
      showPassword: false,
      emailRules: [
        v => !!v || 'El correo es requerido',
        v => /.+@.+\..+/.test(v) || 'Ingresa un correo válido (Ejemplo: usuario@empresa.com)',
        v => (v || '').indexOf(' ') < 0 || 'Los espacios no están permitidos'
      ],
      passwordRules: [
        v => !!v || 'La contraseña es requerida'
      ]
    }
  },
  async beforeCreate () {
    this.$store.dispatch('setUser', {
      isLoggedIn: false,
      user: {}
    })
  },
  mounted () {
    document.addEventListener('keydown', e => {
      if (e.keyCode === 13) this.login()
    })
    if (this.$route.query.email) {
      this.username = this.$route.query.email
    }
  },
  methods: {
    validate () {
      this.isValid = this.$refs.form?.validate() || false
    },
    async login () {
      this.validate()
      if (!this.isValid) return

      const loader = this.$loading.show()
      try {
        await this.$store.dispatch('login', {
          username: this.username,
          password: this.password
        })
        loader.hide()

        const user = this.$store.getters.user
        if (!user) return

        if (user.mustChangePassword && user.recoverKey) {
          this.$router.push({
            name: 'recoverPass',
            query: { k: user.recoverKey, e: this.username }
          })
        } else {
          this.$router.push('/')
          await this.$store.dispatch('survey')
        }
      } catch (error) {
        loader.hide()
        this.$swal({
          title: 'Error',
          html: this.$t(error.data?.error || error),
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#1374F2'
        })
      }
    },
    recoverPass () {
      this.$router.push('/recoverPass')
    }
  }
}
</script>

<style scoped>
.v-application .v-form .error--text {
  color: #df0000 !important;
  caret-color: #df0000 !important;
}

.v-card {
  transition: all 0.3s ease;
}

.v-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.v-btn {
  letter-spacing: 0.5px;
}

.privacy-link {
  color: #1976d2;
  text-decoration: none;
  font-weight: 500;
}

.privacy-link:hover {
  text-decoration: underline;
}

::v-deep .privacy-link {
  color: #1976d2;
}

</style>
